// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page */
.ssa-page {
    padding: 2rem;
    max-width: 1100px;
    margin: 0 auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.ssa-title {
    margin: 0 0 6px;
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a202c;
}

.ssa-subtitle {
    margin: 0 0 2rem;
    color: #64748b;
    font-size: 0.9rem;
}

/* Cards */
.ssa-cards {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
}

.ssa-card {
    width: 280px;
    border: 1.5px solid #e2e8f0;
    border-radius: 14px;
    padding: 1.75rem 1.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    text-align: center;
    background: white;
    position: relative;
    transition: box-shadow 0.2s, border-color 0.2s, transform 0.2s;
}

.ssa-card.active {
    cursor: pointer;
}

.ssa-card.active:hover {
    border-color: #667eea;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.18);
    transform: translateY(-3px);
}

.ssa-card.inactive {
    opacity: 0.45;
    cursor: default;
    background: #fafafa;
}

/* Status badge top-right */
.ssa-card-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 2px 8px;
    border-radius: 20px;
}

.ssa-card-badge.live {
    background: #dcfce7;
    color: #16a34a;
}

.ssa-card-badge.soon {
    background: #f1f5f9;
    color: #94a3b8;
}

/* Logo box */
.ssa-card-logo {
    width: 80px;
    height: 80px;
    border-radius: 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.25rem;
    overflow: hidden;
}

.ssa-card-logo img {
    width: 56px;
    height: 56px;
    object-fit: contain;
}

.ssa-placeholder {
    font-size: 1.4rem;
    color: #cbd5e1;
}

.ssa-card-name {
    font-size: 1rem;
    font-weight: 700;
    color: #1a202c;
}

.ssa-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.5;
}

.ssa-card-action {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: #667eea;
    opacity: 0.8;
}

.ssa-card.active:hover .ssa-card-action {
    opacity: 1;
    text-decoration: underline;
}

/* Overlay - overflow hidden so only modal content scrolls */
.ssa-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
    overflow: hidden;
}

/* Bot Modal */
.bot-modal {
    width: 100%;
    max-width: 900px;
    height: 80vh;
    max-height: 90vh;
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Bot Header */
.bot-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
    flex-shrink: 0;
}

.bot-header-left {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.bot-logo {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.bot-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #1a202c;
}

.bot-subtitle {
    font-size: 0.75rem;
    color: #94a3b8;
}

.bot-close {
    background: none;
    border: none;
    font-size: 1rem;
    color: #94a3b8;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
}

.bot-close:hover {
    background: #f1f5f9;
    color: #475569;
}

/* Messages - scroll fix: min-height 0 lets flex child shrink and scroll */
.bot-messages {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 1rem 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
    background: #f8fafc;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

.bot-msg {
    max-width: 90%;
    padding: 0.6rem 0.9rem;
    border-radius: 10px;
    font-size: 0.875rem;
    line-height: 1.5;
    flex-shrink: 0;
}

.bot-msg.user {
    align-self: flex-end;
    background: #667eea;
    color: white;
    border-bottom-right-radius: 3px;
}

.bot-msg.bot {
    align-self: flex-start;
    background: white;
    border: 1px solid #e2e8f0;
    color: #1a202c;
    border-bottom-left-radius: 3px;
    max-width: 100%;
    padding: 0;
    overflow: visible;
}

.bot-msg.bot span {
    display: block;
    padding: 0.6rem 0.9rem;
}

.bot-msg.error span {
    color: #dc2626;
}

.bot-loading {
    color: #94a3b8;
    font-style: italic;
}

/* Input bar */
.bot-input-bar {
    display: flex;
    gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    border-top: 1px solid #e2e8f0;
    background: white;
    flex-shrink: 0;
}

.bot-input {
    flex: 1 1;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.55rem 0.9rem;
    font-size: 0.875rem;
    outline: none;
    color: #1a202c;
}

.bot-input:focus {
    border-color: #667eea;
}

.bot-send {
    background: #667eea;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.55rem 1.1rem;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
}

.bot-send:hover:not(:disabled) {
    background: #5a6fd6;
}

.bot-send:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

/* SAP Response (friendly answer + table) */
.sap-response {
    padding: 0.6rem 0.9rem;
    width: 100%;
}

.sap-friendly-answer {
    margin: 0 0 0.75rem;
    font-size: 0.9rem;
    line-height: 1.6;
    color: #334155;
    padding: 0;
    background: transparent;
}

.sap-friendly-answer p {
    margin: 0 0 0.5rem;
}
.sap-friendly-answer p:last-child {
    margin-bottom: 0;
}
.sap-friendly-answer strong {
    color: #1a202c;
    font-weight: 600;
}
.sap-friendly-answer ul {
    margin: 0.5rem 0 0;
    padding-left: 1.25rem;
}
.sap-friendly-answer li {
    margin-bottom: 0.35rem;
}

/* SAP Table */
.sap-table-wrap {
    overflow-x: auto;
    width: 100%;
}

.sap-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.78rem;
    min-width: 600px;
}

.sap-table thead tr {
    background: #f1f5f9;
}

.sap-table th {
    padding: 0.5rem 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #475569;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.sap-table td {
    padding: 0.5rem 0.75rem;
    color: #1a202c;
    border-bottom: 1px solid #f1f5f9;
    white-space: nowrap;
}

.sap-table tbody tr:hover td {
    background: #f8fafc;
}

.sap-empty {
    padding: 0.75rem;
    color: #94a3b8;
    font-size: 0.875rem;
    font-style: italic;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .ssa-title,
[data-theme="dark"] .ssa-card-name,
[data-theme="dark"] .bot-title {
  color: var(--text);
}
[data-theme="dark"] .ssa-subtitle,
[data-theme="dark"] .ssa-card-desc,
[data-theme="dark"] .bot-subtitle {
  color: var(--text-muted);
}
[data-theme="dark"] .ssa-card {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .ssa-card.inactive {
  background: var(--surface-2);
}
[data-theme="dark"] .ssa-card-badge.soon {
  background: var(--surface-3);
  color: var(--text-subtle);
}
[data-theme="dark"] .ssa-card-logo {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .bot-modal,
[data-theme="dark"] .bot-input-bar {
  background: var(--surface);
}
[data-theme="dark"] .bot-header,
[data-theme="dark"] .bot-messages {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .bot-close {
  color: var(--text-subtle);
}
[data-theme="dark"] .bot-close:hover {
  background: var(--surface-3);
  color: var(--text);
}
[data-theme="dark"] .bot-msg.bot {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .bot-input {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .sap-friendly-answer {
  color: var(--text-muted);
}
[data-theme="dark"] .sap-friendly-answer strong,
[data-theme="dark"] .sap-table td {
  color: var(--text);
}
[data-theme="dark"] .sap-table thead tr {
  background: var(--surface-3);
}
[data-theme="dark"] .sap-table th {
  color: var(--text-muted);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .sap-table td {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .sap-table tbody tr:hover td {
  background: var(--surface-hover);
}

/* Mobile — desktop layout above unchanged */
@media (max-width: 768px) {
  .ssa-page {
    padding: 1rem;
  }

  .ssa-title {
    font-size: 1.25rem;
  }

  .ssa-cards {
    gap: 1rem;
  }

  .ssa-card {
    width: 100%;
    max-width: none;
  }

  .ssa-overlay {
    padding: 0;
    align-items: stretch;
  }

  .bot-modal {
    max-width: none;
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }

  .bot-header {
    padding: 0.875rem 1rem;
  }

  .bot-messages {
    padding: 0.875rem 1rem;
  }

  .bot-input-bar {
    padding: 0.75rem 1rem;
    padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
  }

  .bot-msg {
    max-width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/self-service-actions/index.css"],"names":[],"mappings":"AAAA,SAAS;AACT;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,8EAA8E;AAClF;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,8DAA8D;AAClE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;IAChD,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA,4DAA4D;AAC5D;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,0EAA0E;AAC1E;IACI,SAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,4DAA4D;AAC5D;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,yDAAyD;EAC3D;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Page */\n.ssa-page {\n    padding: 2rem;\n    max-width: 1100px;\n    margin: 0 auto;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.ssa-title {\n    margin: 0 0 6px;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a202c;\n}\n\n.ssa-subtitle {\n    margin: 0 0 2rem;\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n/* Cards */\n.ssa-cards {\n    display: flex;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.ssa-card {\n    width: 280px;\n    border: 1.5px solid #e2e8f0;\n    border-radius: 14px;\n    padding: 1.75rem 1.5rem 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n    text-align: center;\n    background: white;\n    position: relative;\n    transition: box-shadow 0.2s, border-color 0.2s, transform 0.2s;\n}\n\n.ssa-card.active {\n    cursor: pointer;\n}\n\n.ssa-card.active:hover {\n    border-color: #667eea;\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.18);\n    transform: translateY(-3px);\n}\n\n.ssa-card.inactive {\n    opacity: 0.45;\n    cursor: default;\n    background: #fafafa;\n}\n\n/* Status badge top-right */\n.ssa-card-badge {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    padding: 2px 8px;\n    border-radius: 20px;\n}\n\n.ssa-card-badge.live {\n    background: #dcfce7;\n    color: #16a34a;\n}\n\n.ssa-card-badge.soon {\n    background: #f1f5f9;\n    color: #94a3b8;\n}\n\n/* Logo box */\n.ssa-card-logo {\n    width: 80px;\n    height: 80px;\n    border-radius: 14px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0.25rem;\n    overflow: hidden;\n}\n\n.ssa-card-logo img {\n    width: 56px;\n    height: 56px;\n    object-fit: contain;\n}\n\n.ssa-placeholder {\n    font-size: 1.4rem;\n    color: #cbd5e1;\n}\n\n.ssa-card-name {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #1a202c;\n}\n\n.ssa-card-desc {\n    font-size: 0.8rem;\n    color: #64748b;\n    line-height: 1.5;\n}\n\n.ssa-card-action {\n    margin-top: 0.5rem;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #667eea;\n    opacity: 0.8;\n}\n\n.ssa-card.active:hover .ssa-card-action {\n    opacity: 1;\n    text-decoration: underline;\n}\n\n/* Overlay - overflow hidden so only modal content scrolls */\n.ssa-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n    overflow: hidden;\n}\n\n/* Bot Modal */\n.bot-modal {\n    width: 100%;\n    max-width: 900px;\n    height: 80vh;\n    max-height: 90vh;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* Bot Header */\n.bot-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #e2e8f0;\n    background: #f8fafc;\n    flex-shrink: 0;\n}\n\n.bot-header-left {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.bot-logo {\n    width: 36px;\n    height: 36px;\n    object-fit: contain;\n}\n\n.bot-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #1a202c;\n}\n\n.bot-subtitle {\n    font-size: 0.75rem;\n    color: #94a3b8;\n}\n\n.bot-close {\n    background: none;\n    border: none;\n    font-size: 1rem;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.bot-close:hover {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n/* Messages - scroll fix: min-height 0 lets flex child shrink and scroll */\n.bot-messages {\n    flex: 1 1 0;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 1rem 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    align-items: flex-start;\n    background: #f8fafc;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n}\n\n.bot-msg {\n    max-width: 90%;\n    padding: 0.6rem 0.9rem;\n    border-radius: 10px;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    flex-shrink: 0;\n}\n\n.bot-msg.user {\n    align-self: flex-end;\n    background: #667eea;\n    color: white;\n    border-bottom-right-radius: 3px;\n}\n\n.bot-msg.bot {\n    align-self: flex-start;\n    background: white;\n    border: 1px solid #e2e8f0;\n    color: #1a202c;\n    border-bottom-left-radius: 3px;\n    max-width: 100%;\n    padding: 0;\n    overflow: visible;\n}\n\n.bot-msg.bot span {\n    display: block;\n    padding: 0.6rem 0.9rem;\n}\n\n.bot-msg.error span {\n    color: #dc2626;\n}\n\n.bot-loading {\n    color: #94a3b8;\n    font-style: italic;\n}\n\n/* Input bar */\n.bot-input-bar {\n    display: flex;\n    gap: 0.5rem;\n    padding: 0.75rem 1.25rem;\n    border-top: 1px solid #e2e8f0;\n    background: white;\n    flex-shrink: 0;\n}\n\n.bot-input {\n    flex: 1;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 0.55rem 0.9rem;\n    font-size: 0.875rem;\n    outline: none;\n    color: #1a202c;\n}\n\n.bot-input:focus {\n    border-color: #667eea;\n}\n\n.bot-send {\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 0.55rem 1.1rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.bot-send:hover:not(:disabled) {\n    background: #5a6fd6;\n}\n\n.bot-send:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n/* SAP Response (friendly answer + table) */\n.sap-response {\n    padding: 0.6rem 0.9rem;\n    width: 100%;\n}\n\n.sap-friendly-answer {\n    margin: 0 0 0.75rem;\n    font-size: 0.9rem;\n    line-height: 1.6;\n    color: #334155;\n    padding: 0;\n    background: transparent;\n}\n\n.sap-friendly-answer p {\n    margin: 0 0 0.5rem;\n}\n.sap-friendly-answer p:last-child {\n    margin-bottom: 0;\n}\n.sap-friendly-answer strong {\n    color: #1a202c;\n    font-weight: 600;\n}\n.sap-friendly-answer ul {\n    margin: 0.5rem 0 0;\n    padding-left: 1.25rem;\n}\n.sap-friendly-answer li {\n    margin-bottom: 0.35rem;\n}\n\n/* SAP Table */\n.sap-table-wrap {\n    overflow-x: auto;\n    width: 100%;\n}\n\n.sap-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.78rem;\n    min-width: 600px;\n}\n\n.sap-table thead tr {\n    background: #f1f5f9;\n}\n\n.sap-table th {\n    padding: 0.5rem 0.75rem;\n    text-align: left;\n    font-weight: 600;\n    color: #475569;\n    border-bottom: 1px solid #e2e8f0;\n    white-space: nowrap;\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.sap-table td {\n    padding: 0.5rem 0.75rem;\n    color: #1a202c;\n    border-bottom: 1px solid #f1f5f9;\n    white-space: nowrap;\n}\n\n.sap-table tbody tr:hover td {\n    background: #f8fafc;\n}\n\n.sap-empty {\n    padding: 0.75rem;\n    color: #94a3b8;\n    font-size: 0.875rem;\n    font-style: italic;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .ssa-title,\n[data-theme=\"dark\"] .ssa-card-name,\n[data-theme=\"dark\"] .bot-title {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .ssa-subtitle,\n[data-theme=\"dark\"] .ssa-card-desc,\n[data-theme=\"dark\"] .bot-subtitle {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .ssa-card {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .ssa-card.inactive {\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .ssa-card-badge.soon {\n  background: var(--surface-3);\n  color: var(--text-subtle);\n}\n[data-theme=\"dark\"] .ssa-card-logo {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .bot-modal,\n[data-theme=\"dark\"] .bot-input-bar {\n  background: var(--surface);\n}\n[data-theme=\"dark\"] .bot-header,\n[data-theme=\"dark\"] .bot-messages {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .bot-close {\n  color: var(--text-subtle);\n}\n[data-theme=\"dark\"] .bot-close:hover {\n  background: var(--surface-3);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .bot-msg.bot {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .bot-input {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .sap-friendly-answer {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .sap-friendly-answer strong,\n[data-theme=\"dark\"] .sap-table td {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .sap-table thead tr {\n  background: var(--surface-3);\n}\n[data-theme=\"dark\"] .sap-table th {\n  color: var(--text-muted);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .sap-table td {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .sap-table tbody tr:hover td {\n  background: var(--surface-hover);\n}\n\n/* Mobile — desktop layout above unchanged */\n@media (max-width: 768px) {\n  .ssa-page {\n    padding: 1rem;\n  }\n\n  .ssa-title {\n    font-size: 1.25rem;\n  }\n\n  .ssa-cards {\n    gap: 1rem;\n  }\n\n  .ssa-card {\n    width: 100%;\n    max-width: none;\n  }\n\n  .ssa-overlay {\n    padding: 0;\n    align-items: stretch;\n  }\n\n  .bot-modal {\n    max-width: none;\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n\n  .bot-header {\n    padding: 0.875rem 1rem;\n  }\n\n  .bot-messages {\n    padding: 0.875rem 1rem;\n  }\n\n  .bot-input-bar {\n    padding: 0.75rem 1rem;\n    padding-bottom: max(0.75rem, env(safe-area-inset-bottom));\n  }\n\n  .bot-msg {\n    max-width: 95%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
